import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import ListGroup from 'react-bootstrap/lib/ListGroup';
import ListGroupItem from 'react-bootstrap/lib/ListGroupItem';
import { toPlural, toSeoUrl } from 'helpers/HelperFunctions';
import Loader from 'components/Loader/Loader';
import Thumbnail from 'components/Thumbnails/Thumbnail';
import styles from './ProjectCredits.module.scss';
import LinkOrAnchor from 'components/Shared/LinkOrAnchor';

const ProjectCredits = ({
  credits,
  creditsTotal,
  loadingCredits,
  loggedInUser,
  more,
  onAddCredit,
  onLoadMore,
}) => {
  const alreadyCredited = credits.findIndex((credit) => {
    if (loggedInUser && credit.user.id === loggedInUser.id) {
      return true;
    }

    return false;
  });

  return (
    <ListGroup>
      <ListGroupItem>
        <p className={styles.header}>
          {!loadingCredits && credits.length === 0
            ? 'No credits'
            : `${creditsTotal} credit${creditsTotal !== 1 ? 's' : ''}`}
        </p>
      </ListGroupItem>
      {credits.map((credit, idx) => (
        <ListGroupItem key={idx} className={styles.credit}>
          <Link to={credit.user.links.main_relative}>
            <Thumbnail
              circle
              className={styles.avatar}
              thumbnails={credit.user.avatars}
            />
            <div className={styles.wrapper}>
              <div className={styles.displayname}>
                {credit.user.displayname}
              </div>
              <div className={styles.creditsList}>
                {credit.roles.map((role, idx) => (
                  <span key={idx}>
                    {idx !== 0 ? ',' : ''}{' '}
                    <LinkOrAnchor
                      isLink={false}
                      className={styles.creditLink}
                      title={`Find ${toPlural(role)}`}
                      to={`/find/${toSeoUrl(toPlural(role))}`}
                      onClick={(event) => {
                        event.stopPropagation();
                      }}
                    >
                      {role}
                    </LinkOrAnchor>
                  </span>
                ))}
              </div>
            </div>
          </Link>
        </ListGroupItem>
      ))}
      {loadingCredits && (
        <ListGroupItem>
          <Loader loading />
        </ListGroupItem>
      )}
      {!loadingCredits && more ? (
        <ListGroupItem>
          <a className={styles.loadMore} onClick={() => onLoadMore()}>
            Load more...
          </a>
        </ListGroupItem>
      ) : null}
      {loggedInUser && loggedInUser.type === 'seller' && alreadyCredited < 0 ? (
        <ListGroupItem>
          <a className={styles.addCredits} onClick={() => onAddCredit()}>
            Did you work on this?
          </a>
        </ListGroupItem>
      ) : null}
    </ListGroup>
  );
};

ProjectCredits.propTypes = {
  credits: PropTypes.object,
  creditsTotal: PropTypes.number,
  loadingCredits: PropTypes.bool,
  loggedInUser: PropTypes.object,
  more: PropTypes.func,
  onAddCredit: PropTypes.func,
  onLoadMore: PropTypes.func,
};
export default ProjectCredits;
